import { type SxProps, type Theme } from "@mui/material";

export const DESTRUCTIVE_BUTTON_SX: SxProps<Theme> = {
  color: "#CA4031",
  border: "1px solid #CA4031",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#CA4031",
    color: "white",
  },
};

export const PRIMARY_BUTTON_SX: SxProps<Theme> = {
  color: "#fafafa",
  backgroundColor: "#032e68",
  border: "1px solid #032e68",
  "&:hover": {
    backgroundColor: "#032e68d0",
  },
};
